// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Product } from "../../../data/commerce/product";
import { EnvelopeDocument } from "../base/envelope-document";

export class ProductDocument extends EnvelopeDocument {
	public override Item: Product = new Product();
}